module.exports = __webpack_public_path__ + "static/assets/9c2e381fb6da323e4ab7948c353a629b.svg";